module.exports = __webpack_public_path__ + "static/img/Mariposa.e6f0a1a9.png";